module.exports = __webpack_public_path__ + "img/play-button.c9a4939d.png";